import { em } from 'polished'
import styled from 'styled-components'

export const Video = styled.video`
  height: 100%;
  position: relative;
  left: calc(100% - ${em(710)});

  ${p => p.theme.mq.upMd} {
    height: 100%;
    min-height: ${em(829)};
    left: -${em(500)};
  }

  ${p => p.theme.mq.upLg} {
    left: -${em(396)};
    min-height: auto;
  }
`

export const VideoWrapper = styled.div`
  height: 100%;
  ${p => p.theme.mq.upMd} {
    width: ${em(454)};
    transform: none;
  }

  ${p => p.theme.mq.upLg} {
    width: ${em(518)};
    overflow: hidden;
    height: 100%;
    position: relative;
  }
`
